import { Button, type ButtonProps } from "antd"
import React from "react"

import { cn } from "../../utils/cn.ts"

interface ButtonComponentProps extends ButtonProps {
  text?: string
}

export const ButtonComponent = ({
  className,
  text = "",
  onClick,
  ...props
}: ButtonComponentProps) => {
  return (
    <Button onClick={onClick} className={cn(className, "btn")} {...props}>
      {text}
      {props.children}
    </Button>
  )
}

export default ButtonComponent
